import AcUnitIcon from "@mui/icons-material/AcUnit";
import BoltIcon from "@mui/icons-material/Bolt";
import ForwardToInboxIcon from "@mui/icons-material/ForwardToInbox";
import PoolIcon from "@mui/icons-material/Pool";
import ThermostatIcon from "@mui/icons-material/Thermostat";
import { Box, Button, Container, Typography } from "@mui/material";
import { PageWithNav } from "features/Navbar/PageWithNav";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import { WorklistTools } from "../shared/interfaces";

export const WorklistLandingPage = () => {
  const history = useHistory();

  const navigateToTool = (methodId: number) => {
    history.push(`/worklist-tools/${methodId}`);
  };

  const StyledWorklistButton = styled(Button)`
    height: 75px;
    flex: 0 1 calc(50% - 24px);
    max-width: 300px;
    min-width: 200px;
    display: flex;
    justify-content: center;

    @media (max-width: 800px) {
      flex: 1 1 100%;
    }
  `;

  return (
    <PageWithNav>
      <Container maxWidth="sm" sx={{ width: "100%", overflowX: "hidden" }}>
        <Box py={6}>
          <Typography variant="h4" gutterBottom textAlign="center">
            Select Worklist Generator
          </Typography>
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "center",
              gap: 6,
              mt: 7,
            }}
          >
            <StyledWorklistButton
              variant="contained"
              onClick={() => navigateToTool(WorklistTools.Thaw)}
            >
              <ThermostatIcon sx={{ mr: 1 }} />
              Thaw
            </StyledWorklistButton>

            <StyledWorklistButton
              variant="contained"
              onClick={() => navigateToTool(WorklistTools.PoolingNormalization)}
            >
              <PoolIcon sx={{ mr: 1 }} />
              Pooling Norm
            </StyledWorklistButton>

            <StyledWorklistButton
              variant="contained"
              onClick={() => navigateToTool(WorklistTools.Twelve24TC)}
            >
              <AcUnitIcon sx={{ mr: 1 }} />
              1224TC
            </StyledWorklistButton>

            <StyledWorklistButton
              variant="contained"
              onClick={() => navigateToTool(WorklistTools.ExternalThaw)}
            >
              <ForwardToInboxIcon />
              <ThermostatIcon sx={{ mr: 1 }} />
              External Thaw
            </StyledWorklistButton>
            <StyledWorklistButton
              variant="contained"
              onClick={() => navigateToTool(WorklistTools.Nucleofection)}
            >
              <BoltIcon sx={{ mr: 1 }} />
              Nucleofection
            </StyledWorklistButton>
          </Box>
        </Box>
      </Container>
    </PageWithNav>
  );
};
